import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=0361b20c&scoped=true&"
import script from "./EmailVerification.vue?vue&type=script&lang=js&"
export * from "./EmailVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=0361b20c&prod&lang=css&"
import style1 from "./EmailVerification.vue?vue&type=style&index=1&id=0361b20c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361b20c",
  null
  
)

export default component.exports